<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="addlinks-dialog"
  >
    <wechat-form
      ref="form"
      @submit="submitHandle"
    ></wechat-form>
  </sliderBarDialogShell>
</template>

<script>
import { saveWechatConfig } from '@/api/sys/robitConfig/wechat'
import wechatForm from '@/components/sys/robitCofig/wechat/wechatForm'

export default {
  name: 'addweChat',
  components:{
    wechatForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      title: '新增企业微信推送渠道'
    }
  },
  methods: {
    beforeClose(){
      this.close();
    },
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },

    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
      let params = {
          name: formData.robitName,
          desc: formData.desc,
          hookUrl: formData.hookUrl,
          status: formData.status,
      }
      saveWechatConfig(params).then((res) => {
        this.$refs.form.$refs.form.clearValidate();
        this.$refs.form.$refs.form.resetFields();

        this.$emit('add-success');
        this.$refs.form.reset();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
<style>
@media screen and (min-width: 768px) {
  .addlinks-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
